import { render, staticRenderFns } from "./TurmacrudLocal.vue?vue&type=template&id=44833078&scoped=true&"
import script from "./TurmacrudLocal.vue?vue&type=script&lang=js&"
export * from "./TurmacrudLocal.vue?vue&type=script&lang=js&"
import style0 from "./TurmacrudLocal.vue?vue&type=style&index=0&id=44833078&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44833078",
  null
  
)

export default component.exports